module.exports = __webpack_public_path__ + "img/appleStoreBg.34630fc4.png";